import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../../hooks/axiosInstance";
import ViewOrderPayment from "../../../components/Modal/Admin/Payment/ViewOrderPayment";
import { toast } from "react-toastify";
import Pusher from "pusher-js";
import { Oval } from "react-loader-spinner";
import Scrollbars from "react-custom-scrollbars-2";


export default function Payment() {
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState("");
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({});
    const [showView, setShowView] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [order, setOrder] = useState(null);
    const [orders, setOrders] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [statusFilter, setStatusFilter] = useState("");

    const storedPermissions = localStorage.getItem("userPermissions");
    const userDataString = localStorage.getItem("userData");
    let userTypeId = null;

    if (userDataString) {
        const userData = JSON.parse(userDataString);
        userTypeId = userData.user.user_type_id;
    } else {
        console.log("No user data found");
    }

    const permissions = storedPermissions ? JSON.parse(storedPermissions) : [];

    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            try {
                const endpoint = "/user/payment/get-payment";
                const orderResponse = await axiosInstance.get(endpoint, {
                    params: {
                        page,
                        filter,
                        start_date: startDate, // Pass start date
                        end_date: endDate,     // Pass end date
                        status: statusFilter,
                    },
                });

                const fetchedOrders = orderResponse.data.data.payment.data;
                // Group orders by order_code and sum total_price and quantity
                const groupedOrders = fetchedOrders.reduce((acc, order) => {
                    const key = order.order_code; // Unique key based on order_code
                    if (!acc[key]) {
                        acc[key] = {
                            ...order,
                            sum_total_price: 0, // Initialize sum_total_price
                            sum_quantity: 0,
                            payment_status: 'paid',
                        };
                    }
                    // Sum total_price and quantity for all payment types
                    acc[key].sum_total_price += order.total_price;
                    acc[key].sum_quantity += order.quantity;
                    // Track payment status for the group
                    if (order.payment_status === null) {
                        acc[key].payment_status = "pending"; // If any order is unpaid, set group status to pending
                    } else if (order.payment_status === "partly_paid" && acc[key].payment_status !== "pending") {
                        acc[key].payment_status = "partly_paid"; // If any order is partly_paid, set group status to pending
                    }
                    return acc;
                }, {});

                // Convert groupedOrders object back to array
                // const ordersArray = Object.values(groupedOrders);
                const ordersArray = Object.values(groupedOrders).map(group => {
                    return {
                        ...group, // Use the first order details for display
                        payment_statusss: group.payment_status, // Set the group payment status
                        sum_total_price: group.sum_total_price,
                        sum_quantity: group.sum_quantity,
                    };
                });

                setOrders(ordersArray);
                setPagination(orderResponse.data.data.payment);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [userTypeId, page, filter, refreshKey, startDate, endDate, statusFilter]);

    // Filter orders to show only the first instance of each unique order_code
    const uniqueOrders = Array.from(new Map(orders.map(order => [order.order_code, order])).values());

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const handleStartDateChange = (event) => {
        setStartDate(event.target.value);
    };

    const handleEndDateChange = (event) => {
        setEndDate(event.target.value);
    };

    const handleStatusFilterChange = (event) => {
        setStatusFilter(event.target.value);
    };
    const handleShowView = (ord) => {
        setOrder(ord);
        setShowView(true);
    };

    const handleClose = () => {
        setShowView(false);
    };

    const handleRefresh = () => {
        setRefreshKey((prevRefreshKey) => prevRefreshKey + 1);
    };

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= pagination.last_page) {
            setPage(newPage);
        }
    };

    const handleFilterChange = (event) => {
        setFilter(event.target.value);
        setPage(1);
    };

    // useEffect(() => {

    //     const pusher = new Pusher('210f3e2c853e18bb67ed', {
    //         cluster: 'us3',
    //         forceTLS: true,
    //         debug: true,
    //         // disabledTransports: ['ws']
    //     });
    //     // Check the connection state
    //     pusher.connection.bind('connected', function () {
    //         console.log('Pusher connected');
    //     });

    //     pusher.connection.bind('error', function (error) {
    //         console.log('Pusher error:', error);
    //     });

    //     const channel = pusher.subscribe('orders-channel');
    //     channel.bind('my-event', function (data) {
    //         alert(JSON.stringify(data));
    //     });

    //     channel.bind('order-status-updated', function (data) {

    //         console.log('Received event:', data);  // Log data to inspect the received structure
    //         // if (data && data.order_code && data.status) {
    //         //     alert(JSON.stringify(data));
    //         //     toast.success(`Order ${data.order_code} status updated to: ${data.status}`);
    //         // }
    //     });

    //     return () => {
    //         pusher.unsubscribe('orders-channel');
    //     };
    // }, []);

    // useEffect(() => {
    //     const pusher = new Pusher("210f3e2c853e18bb67ed", {
    //         cluster: "us3",
    //         forceTLS: true,
    //         debug: true,
    //         // disabledTransports: ['ws']
    //     });
    //     // Check the connection state
    //     pusher.connection.bind("connected", function () {
    //         console.log("Pusher connected");
    //     });

    //     pusher.connection.bind("error", function (error) {
    //         console.log("Pusher error:", error);
    //     });

    //     const channel = pusher.subscribe("my-channel");
    //     // channel.bind("my-event", function (data) {
    //     //     alert(JSON.stringify(data));
    //     // });

    //     channel.bind("my-event", function (data) {
    //         console.log("Received event:", data); // Log data to inspect the received structure
    //         // Ensure the `data` structure has an `order` object
    //         if (data && data.order) {
    //             const { order } = data;

    //             if (order.order_code && order.status) {
    //                 console.log(`Order ${order.order_code} status is now: ${order.status}`);

    //                 // Update the order list based on the new data
    //                 const updatedOrderList = orders.map((existingOrder) => {
    //                     if (existingOrder.order_code === order.order_code) {
    //                         return { ...existingOrder, payment_status: order.status };
    //                     }
    //                     return existingOrder;
    //                 });

    //                 setOrders(updatedOrderList);
    //                 toast.success(`Order ${order.order_code} status updated to: ${order.status}`);
    //             } else {
    //                 console.log("Order data is missing required fields:", order);
    //             }
    //         } else {
    //             console.log("Data format is incorrect:", data);
    //         }
    //     });

    //     return () => {
    //         pusher.unsubscribe("my-channel");
    //     };
    // }, []);
    return (
        <>
            {/* Page Title and Breadcrumbs */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0" style={{ color: "#c4281c" }}>
                            Order Payment Approval
                        </h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item">
                                    <Link to="/app/dashboard">Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item active" style={{ color: "#c4281c" }}>
                                    Order Payment Approval
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            {loading && !filter ? (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "80vh" }}
                >
                    <Oval
                        height={80}
                        width={80}
                        color="#FF0200"
                        visible={true}
                        ariaLabel="oval-loading"
                        secondaryColor="#4fa94d"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                    />
                </div>
            ) : (

                <div className="row" id="contactList">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header d-flex align-items-center border-0">
                                <h5 className="card-title mb-0 flex-grow-1" style={{ color: "#c4281b" }}>
                                    Order Payment Approval
                                </h5>
                            </div>
                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <div className="row mb-3">
                                    <div className="col-xl-4 col-md-6">
                                        <div className="input-group mb-2">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    Start&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                                </span>
                                            </div>
                                            <input
                                                type="date"
                                                className="form-control mb-2"
                                                placeholder="Start Date"
                                                value={startDate}
                                                onChange={handleStartDateChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-md-6">
                                        <div className="input-group mb-2">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    End&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                                </span>
                                            </div>
                                            <input
                                                type="date"
                                                className="form-control mb-2"
                                                placeholder="End Date"
                                                value={endDate}
                                                onChange={handleEndDateChange}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="row mb-3">
                                    <div className="col-xl-4 col-md-6">
                                        <div className="search-box">
                                            <input
                                                type="text"
                                                className="form-control search"
                                                placeholder="Search..."
                                                value={filter}
                                                onChange={handleFilterChange}
                                            />
                                            <i className="ri-search-line search-icon"></i>
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-md-6">
                                        <div className="input-group mb-2">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    Payment Status&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                                </span>
                                            </div>
                                            <select
                                                className="form-select"
                                                value={statusFilter}
                                                onChange={handleStatusFilterChange}
                                            >
                                                <option value="">All Status</option>
                                                <option value="paid">Paid</option>
                                                    {/* <option value="unpaid">Unpaid</option> */}
                                                    <option value="partly_paid">Partly Paid</option>
                                                    {/* <option value='null'>Pending</option> */}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                {/* <Scrollbars style={{ width: '100%', height: 200 }}> */}
                                    <div className="table-responsive table-card">
                                        <table className="table align-middle table-nowrap table-striped table-borderless table-hover" id="customerTable">
                                            <thead className="table-light text-muted">
                                                <tr>
                                                    <th scope="col">#</th>
                                                    <th scope="col">Company Name</th>
                                                    <th scope="col">Product Name</th>
                                                    <th scope="col">Sale Man</th>
                                                    <th scope="col">Payment type</th>
                                                    <th scope="col">Order Code</th>
                                                    <th scope="col">Quantity</th>
                                                    <th scope="col">Total Price</th>
                                                    <th scope="col">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                                {uniqueOrders.length > 0 ? (
                                                    uniqueOrders.map((ord, index) => (
                                                        <tr key={ord.id}>
                                                            <td>{index + 1}</td>
                                                            <td>{ord.company_name}</td>
                                                            <td>{ord.product_name}</td>
                                                            <td>{ord.first_name} {ord.last_name}</td>
                                                            <td>{ord.payment_type && ord.payment_type==='cash' ? "Cash/Prepaid" : ord.payment_type}</td>
                                                            {/* <strong>Payment Type:</strong> {orderInfo.payment_type && orderInfo.payment_type === "cash" ? "Cash/Prepaid" : orderInfo.payment_type} */}
                                                            <td>{ord.order_code}</td>
                                                            <td>{ord.sum_quantity || ord.quantity}</td>
                                                            <td>{ord.sum_total_price || ord.total_price}</td>
                                                            {/* <td className="status">
                                                        {ord.payment_status === "paid" ? (
                                                            <span className="badge bg-success">Paid</span>
                                                        ) : ord.payment_status === "unpaid" ? (
                                                            <span className="badge bg-warning">UnPaid</span>
                                                            ) : ord.payment_status === 'partly_paid' ? (
                                                                    <span className="badge bg-danger">Partly paid</span>
                                                                ) : ord.payment_status === 'null' ? (
                                                                        <span className="badge bg-danger">Unpaid</span>
                                                                        ) : ord.payment_status === 'null' ? (
                                                                    <span className="badge bg-danger">Unpaid</span>
                                                        ) : (
                                                            <span className="badge bg-info">{ord.payment_status}</span>
                                                        )}
                                                    </td> */}
                                                            <td className="status">
                                                                {ord.payment_status === "paid" ? (
                                                                    <span className="badge bg-success">Paid</span>
                                                                ) : ord.payment_status === "partly_paid" ? (
                                                                    <span className="badge bg-danger">Partly Paid</span>
                                                                ) : ord.payment_status === "unpaid" || ord.payment_status === "null" ? (
                                                                    <span className="badge bg-warning">Pending</span>
                                                                ) : (
                                                                    <span className="badge bg-info">{ord.payment_status}</span>
                                                                )}
                                                            </td>

                                                            <td>
                                                                <div className="dropdown">
                                                                    <button
                                                                        className="btn btn-icon btn-sm fs-16 text-muted dropdown"
                                                                        type="button"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <i className="mdi mdi-apps"></i>
                                                                    </button>
                                                                    <ul className="dropdown-menu">
                                                                        <li>
                                                                            <Link
                                                                                className="dropdown-item"
                                                                                onClick={() => handleShowView(ord)}
                                                                            >
                                                                                <i className="ri-eye-fill text-muted me-2 align-bottom"></i>
                                                                                View Order Info
                                                                            </Link>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">No orders found.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                {/* </Scrollbars> */}
                                    <div className="d-flex mt-5 mb-5 flex-wrap">
                                        <div className="pagination-wrap hstack gap-2 mx-auto">
                                        <ul className="pagination">
                                            <li className={`page-item ${pagination.current_page === 1 ? "disabled" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(pagination.current_page - 1)}
                                                    disabled={pagination.current_page === 1}
                                                >
                                                    Previous
                                                </button>
                                            </li>
                                            {Array.from({ length: pagination.last_page }, (_, index) => index + 1).map((pageNumber) => (
                                                <li key={pageNumber} className={`page-item ${pageNumber === pagination.current_page ? "active" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => handlePageChange(pageNumber)}
                                                    >
                                                        {pageNumber}
                                                    </button>
                                                </li>
                                            ))}
                                            <li className={`page-item ${pagination.current_page === pagination.last_page ? "disabled" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(pagination.current_page + 1)}
                                                    disabled={pagination.current_page === pagination.last_page}
                                                >
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            <ViewOrderPayment
                showView={showView}
                order={order}
                closeModal={handleClose}
                refreshPage={handleRefresh}
            />
        </>
    );
}
